'use client'

import { useState } from 'react'

export interface ISelectValue {
  isOpen: boolean
  value?: string
  label?: string
}
export interface ISelectStates {
  [key: string]: ISelectValue
}
export interface IParamsSelect {
  selects: ISelectStates
  onlyOneSelectorOpen?: boolean
}
export const useSelects = ({
  selects,
  onlyOneSelectorOpen = false
}: IParamsSelect) => {
  const [selectStates, setSelectStates] = useState<ISelectStates>(selects)
  const onSelectChange = ({
    value,
    name
  }: {
    value: ISelectValue
    name: string
  }) => {
    const updatedState: ISelectStates = {}

    updatedState[name] = { ...selectStates[name], ...value }

    if (value.isOpen && onlyOneSelectorOpen) {
      Object.keys(selectStates).forEach((key) => {
        if (key !== name) {
          updatedState[key] = { ...selectStates[key], isOpen: false }
        }
      })
    }

    setSelectStates({ ...selectStates, ...updatedState })
  }
  const onCloseSelectorByName = (name: string) => {
    setSelectStates({
      ...selectStates,
      [name]: { ...selectStates[name], isOpen: false }
    })
  }
  const onResetSelects = (resetValue: ISelectStates) => {
    setSelectStates(resetValue)
  }
  return {
    onCloseSelectorByName,
    onResetSelects,
    onSelectChange,
    selectStates
  }
}
